import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowDown } from 'lucide-react';
export function ProductRevealSection() {
  const includes = ["Guida completa all'alimentazione infantile sana", 'Oltre 200 ricette veloci e pratiche per colazioni, pranzi e merende', 'Menù settimanali pronti e liste della spesa organizzate', 'Suggerimenti di combinazioni per merende nutrienti e gustose', 'Opzioni adatte alla congelazione per risparmiare tempo', 'Lista di sostituti degli ingredienti per adattarsi a ciò che hai in casa', 'Struttura di un pasto equilibrato: cosa includere e cosa evitare'];
  return <section className="bg-gray-50 py-16 px-4" data-id="element-167">
      <div className="max-w-4xl mx-auto text-center" data-id="element-168">
        <h2 className="text-3xl md:text-4xl font-extrabold text-[#1f2e10] mb-12" data-id="element-169">
          Riceverai con il tuo accesso:
        </h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="relative max-w-2xl mx-auto mb-12" data-id="element-170">
          <img src="https://cdn.magicpatterns.com/uploads/oCq1yehqaBUiXRMRycJGai/ChatGPT_Image_6_jun_2026,_16_43_26.png" alt="Guida Merende Felici con tutti i bonus inclusi" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-171" />
        </motion.div>

        <div className="bg-white p-8 rounded-3xl shadow-lg border border-gray-100 text-left max-w-2xl mx-auto mb-12" data-id="element-172">
          <div className="text-center mb-6" data-id="element-173">
            <span className="inline-block bg-green-100 text-green-800 text-xs font-bold px-3 py-1 rounded-full mb-2" data-id="element-174">
              INCLUDE
            </span>
            <h3 className="text-2xl font-bold text-[#1f2e10]" data-id="element-175">
              Merende Felici™
            </h3>
          </div>
          <ul className="space-y-4" data-id="element-176">
            {includes.map((item, idx) => <motion.li key={idx} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="flex items-start gap-3" data-id="element-177">
                <div className="mt-1 bg-green-100 rounded-full p-1 flex-shrink-0" data-id="element-178">
                  <Check size={16} className="text-green-600" data-id="element-179" />
                </div>
                <span className="text-gray-700 font-medium" data-id="element-180">{item}</span>
              </motion.li>)}
          </ul>
        </div>

        <div className="flex flex-col items-center gap-4" data-id="element-181">
          <p className="text-xl font-bold text-[#1f2e10]" data-id="element-182">E molto di più...</p>
          <motion.div animate={{
          y: [0, 10, 0]
        }} transition={{
          repeat: Infinity,
          duration: 1.5
        }} data-id="element-183">
            <ArrowDown size={32} className="text-green-600" data-id="element-184" />
          </motion.div>
        </div>
      </div>
    </section>;
}